import { Component, EventEmitter, Output, OnInit, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TechnicalEvaluationCriteriaComponent } from "@/app/components/projects/project-development/tendering/inivitation-to-tender/evaluation-criteria-wrapper/technical-evaluation-criteria/technical-evaluation-criteria.component";
import { CommercialEvaluationCriteriaComponent } from "@/app/components/projects/project-development/tendering/inivitation-to-tender/evaluation-criteria-wrapper/commercial-evaluation-criteria/commercial-evaluation-criteria.component";

@Component({
  selector: 'app-evaluation-criteria-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    TechnicalEvaluationCriteriaComponent,
    CommercialEvaluationCriteriaComponent,
  ],
  templateUrl: './evaluation-criteria-wrapper.component.html',
  styleUrl: './evaluation-criteria-wrapper.component.css',
})
export class EvaluationCriteriaWrapperComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();

  projectId: number;
  projectName: string;
  @Input() currentStep = 1;
  tenderInfo : any

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
    });
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
    });
    this.tenderInfo = this.data?.tenderResponse;
    this.currentStep = this.data?.currentStep;
  }

  nextStep() {
    if (this.currentStep < 2) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

}
